import React from 'react';
import './Heading.css';



const Heading = ({title, span = '', sideHeading = false, linear = false}) => { 
  return ( 

    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>

      {/* Render the subTitle section only if subTitle is provided */}
      {span && (
        <span>{span}</span>
      )}

      {/* Heading title */}
      <h2>{title}</h2> 

    </div>

  ) 
} 

export default Heading